import { render, staticRenderFns } from "./StockLevels.vue?vue&type=template&id=1c74b8c2&"
import script from "./StockLevels.vue?vue&type=script&lang=js&"
export * from "./StockLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports